// @flow
import eshopOrderClick                   from 'fg-frontend/webActions/eshopOrderClick';
import eshopComparisonShowDifferentLines from 'fg-frontend/webActions/eshopComparisonShowDifferentLines';

import eshopUserToolsHandle  from './webActions/eshopUserToolsHandle';
import eshopUserToolsRefresh from './webActions/eshopUserToolsRefresh';

export default (action) => {
	switch (action) {
		case 'eshopUserToolsRefresh':
			return eshopUserToolsRefresh;
		case 'eshopOrderClick':
			return eshopOrderClick;
		case 'eshopComparisonShowDifferentLines':
			return eshopComparisonShowDifferentLines;
		case 'eshopUserToolsHandle':
			return eshopUserToolsHandle;
	}
};



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/configureEshopActions.js